import { FormControl, Grid, makeStyles, Typography } from '@material-ui/core';
import CustomerSelect from 'App/Vehicles/shared/CustomerSelect';
import LocationSelect from 'App/Vehicles/shared/LocationSelect';
import React from 'react';

import { FormSubmitHandler, SubmitButton } from 'Elements/Form';
import DayrangePicker from 'Elements/Form/Dayrange/Dayrange';
import Form from 'Elements/Form/Form';
import ResetButton from 'Elements/Form/ResetButton';
import SearchPane from 'Elements/SearchPane/SearchPane';

import schema, { initialValues, Schema } from './schema';

const useStyles = makeStyles(theme => ({
  checkbox: {
    padding: '2px 9px'
  },
  formLabel: {
    margin: '10px 0px 10px 15px',
    fontSize: '12px'
  },
  button: {
    marginLeft: theme.spacing(1)
  }
}));

type Props = {
  onSubmit: FormSubmitHandler<Schema>;
};

export default function ActionsForm({ onSubmit }: Props) {
  const classes = useStyles();

  return (
    <SearchPane>
      <Typography variant="h6">Suodattimet</Typography>
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        validationSchema={schema}
      >
        <CustomerSelect name="owner_id" />

        <CustomerSelect
          name="customer_id"
          helperText="Yritys, jolle rengas on varattu"
        />

        <LocationSelect name="location_id" />

        <FormControl fullWidth>
          <DayrangePicker name="range" />
        </FormControl>
        <Grid container justify="flex-end">
          <ResetButton className={classes.button} variant="contained">
            Nollaa
          </ResetButton>
          <SubmitButton
            className={classes.button}
            variant="contained"
            color="secondary"
          >
            Suodata
          </SubmitButton>
        </Grid>
      </Form>
    </SearchPane>
  );
}
